import { render, staticRenderFns } from "./TicketsBase.vue?vue&type=template&id=52823507"
import script from "./TicketsBase.vue?vue&type=script&lang=ts"
export * from "./TicketsBase.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports